import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, CreditCard, Truck } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-heading font-black text-3xl mb-4">
            <span className="text-[#B026FF] neon-glow-pink">GK</span>
            <span>Led</span>
          </div>
          <p className="text-zinc-400 max-w-md text-sm leading-relaxed">
            Χειροποίητες flex neon επιγραφές για σπίτι, επιχείρηση και ειδικές εκδηλώσεις.
            Φωτίζουμε τις ιδέες σας.
          </p>
          <div className="flex gap-3 mt-6">
            <span className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 text-xs text-zinc-300">
              <CreditCard size={14} /> Κάρτα
            </span>
            <span className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 text-xs text-zinc-300">
              <Truck size={14} /> Αντικαταβολή
            </span>
          </div>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-bold mb-4">
            Πλοήγηση
          </div>
          <ul className="flex flex-col gap-2">
            <li><Link to="/" className="text-zinc-300 hover:text-[#B026FF] text-sm">Αρχική</Link></li>
            <li><Link to="/artworks" className="text-zinc-300 hover:text-[#B026FF] text-sm">Artworks</Link></li>
            <li><Link to="/project" className="text-zinc-300 hover:text-[#B026FF] text-sm">Η ιδέα σου</Link></li>
            <li><Link to="/contact" className="text-zinc-300 hover:text-[#B026FF] text-sm">Επικοινωνία</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-bold mb-4">
            Επικοινωνία
          </div>
          <ul className="flex flex-col gap-3 text-sm text-zinc-300">
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#B026FF]"/> gkledbusiness@gmail.com</li>
            <li>
              <a
                href="tel:+306999794496"
                className="flex items-center gap-2 hover:text-[#B026FF] transition-colors"
                data-testid="footer-phone-link"
              >
                <Phone size={14} className="text-[#B026FF]"/> +30 699 979 4496
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/gkled_/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#B026FF] transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram size={14} className="text-[#B026FF]"/> @gkled_
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <div>© 2026 GKLed · ΓΚΑΤΖΗΣ ΑΡΓΥΡΙΟΣ · ΑΦΜ 173822071</div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 justify-center">
            <Link to="/terms" className="hover:text-[#B026FF] transition-colors" data-testid="footer-terms">Όροι Χρήσης</Link>
            <Link to="/returns" className="hover:text-[#B026FF] transition-colors" data-testid="footer-returns">Επιστροφές</Link>
            <Link to="/privacy" className="hover:text-[#B026FF] transition-colors" data-testid="footer-privacy">Απόρρητο</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
